<div class="content-card filters">
  <div class="top">
    <div class="top__left">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <button mat-icon-button (click)="previousMonth()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <span class="date-label" (click)="picker.open()">
            {{ currentDate | date : 'MM.yyyy' }}
          </span>
          <button mat-icon-button class="calendar-picker" (click)="picker.open()">
            <mat-icon>event</mat-icon>
          </button>
          <button mat-icon-button (click)="nextMonth()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
          <div class="datepicker">
            <input matInput [matDatepicker]="picker" readonly />
            <mat-datepicker #picker startView="year" [startAt]="currentDate"
            (monthSelected)="onDateChange($event, picker)"></mat-datepicker>
          </div>
        </div>
      </div>
    </div>
    <div class="top__right">
      @if (showFilterPresetSelector) {
        <mat-form-field [@inOutAnimation] appearance="outline"
          class="filter-preset-selector">
          <mat-label>Filtr</mat-label>
          <mat-select [value]="selectedFilterPresetId" (valueChange)="setSelectedFilterPresetId($event)">
            @for (preset of filterPresets; track preset) {
              <mat-option [value]="preset.Id">{{
                preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <button (click)="resetFilters()" class="top__button top__button-clear">
        <mat-icon>close</mat-icon>
        {{ 'Reset' | translate }}
      </button>
      <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
        <mat-icon>filter_alt</mat-icon>
        {{ 'Filter' | translate }}
      </button>
    </div>
  </div>
  @if (areFiltersExpanded) {
    <app-holiday-per-month-list-filters [formGroup]="filtersFormGroup"
      (filterGridData)="filterData($event)">
      <div class="favorite-button-row-container">
        <button (click)="saveFilterPresetButtonClick()" class="favorite-button">
          @if (isSavedFilterPreset) {
            <mat-icon>bookmark</mat-icon>
            {{ 'UnsaveFilter' | translate }}
          } @else {
            <mat-icon>bookmark_border</mat-icon>
            {{ 'SaveFilter' | translate }}
          }
        </button>
      </div>
    </app-holiday-per-month-list-filters>
  }
</div>

<div class="content-card table-card">
  <div class="table-wrapper custom-table">
    <mat-table #table matSort matSortActive="company" matSortDirection="desc" matSortDisableClear
      [dataSource]="dataSource.holidays$ | async">
      <ng-container matColumnDef="workerFullName" [sticky]="screenService.isAboveMd$ | async">
        <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
          {{ 'WorkerFullName' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.LastName + ' ' + element.FirstName"
          [matTooltipPosition]="'above'"><a [routerLink]="['/profile', element.WorkerId, 'timesheets']" tabindex="-1">{{
        element.LastName }} {{ element.FirstName }}</a></mat-cell>
      </ng-container>

      <ng-container matColumnDef="company">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Company' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.Company" [matTooltipPosition]="'above'">{{
        element.Company }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="employer">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Employer' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.Employer" [matTooltipPosition]="'above'">{{
        element.Employer }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="employerObject">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'EmployerObject' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.EmployerObject" [matTooltipPosition]="'above'">{{
          element.EmployerObject
        }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      @for (d of days; track d; let i = $index) {
        <ng-container [matColumnDef]="d.label">
          <mat-header-cell *matHeaderCellDef [mat-sort-header]="d.date | date : 'yyyy-MM-dd'"
            class="hidden-sort calendar-column"
            [ngClass]="{ saturdays: d.date.getDay() === DayEnum.SATURDAYS, sunday: d.date.getDay() === DayEnum.SUNDAY, holiday: isHoliday(d.date) }">
            {{ d.label }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="calendar-column calendar-cell">
          <div class="card calendar" [ngClass]="{
              green: element.AbsenceDays[i]?.Absences?.length && element.AbsenceDays[i].Absences[0].AbsenceStatusId === AbsenceStatus.Accepted,
              yellow:
                element.AbsenceDays[i]?.Absences?.length && element.AbsenceDays[i].Absences[0].AbsenceStatusId === AbsenceStatus.PendingApproval,
              grey: element.AbsenceDays[i]?.Absences?.length && element.AbsenceDays[i].Absences[0].AbsenceStatusId === AbsenceStatus.Draft
            }">
              @if (element.AbsenceDays[i]?.TimeTicksSum) {
                {{ element.AbsenceDays[i].TimeTicksSum | ticksToString : 'dd' }}
              }
            </div>
          </mat-cell>
        </ng-container>
      }

      <ng-container matColumnDef="approvedSum" stickyEnd>
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort sum-column">
          {{ 'HolidayPerMonthList.ApprovedSum' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="sum-column sum-cell">
          <div class="card">
            {{ element.ApprovedSum | ticksToString : 'dd' }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pendingApprovalSum" stickyEnd>
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort sum-column">
          {{ 'HolidayPerMonthList.PendingApprovalSum' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="sum-column sum-cell">
          <div class="card">
            {{ element.PendingApprovalSum | ticksToString : 'dd' }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="draftSum" stickyEnd>
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort sum-column">
          {{ 'HolidayPerMonthList.DraftSum' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="sum-column sum-cell">
          <div class="card">
            {{ element.DraftSum | ticksToString : 'dd' }}
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="25" [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>
</div>